
import React, {useEffect, useState} from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Title, Icon } from '../../../components/components';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FilterButton, { FilterGroup } from '../../../components/FilterButton';
import Tabs from '../../../components/Tabs';
import { useGetAppQuery } from '../../../api/appApiSlice';
import DataByDay from '../../../components/app/DataByDay';
import {DateRangeFilterButton} from "../../../components/DateRangeFilterButton";
import Kpis from "../../../components/metrics/Kpis";
import ConsentTab from '../../../components/app/ConsentTab';
import VersionTab from '../../../components/app/admin/VersionTab';
import LazyLoad from '../../../components/LazyLoad';
import AppSubTitle from '../../../components/app/AppSubtitle';


const App = () => {
  const appId = useParams()["appId"];
  const [filter, setFilter] = useState({})
  const { t } = useTranslation();
  const { data: app = {}, isSuccess } = useGetAppQuery({appId, filter})
  const { sdk_versions = [], app_versions = [] } = app
  const history = useHistory();
  const [selectedAppVersion, setSelectedAppVersion] = useState(app_versions)
  const [selectedSdkVersion, setSelectedSdkVersion] = useState(sdk_versions)
  useEffect(() => {
    if (filter.app_version) {
      setSelectedAppVersion(filter.app_version)
    }
    if (filter.sdk_version) {
      setSelectedSdkVersion(filter.sdk_version)
    }
  }, [filter])
  useEffect(()=> {
    setSelectedAppVersion(app_versions)
  }, [app_versions.toString()])
  useEffect(()=> {
    setSelectedSdkVersion(sdk_versions)
  }, [sdk_versions.toString()])

  if (! (app.bundle_id || app.bundle_id || app.devices ) ) { return(<></>) }

  return ( <>
    <Title main={app.publisher.name} sub={(<AppSubTitle app={app}/>)} group={true} onBack={()=>(history.goBack())} >
      <Button onClick={()=>( window.location = `/apps/${appId}/admin`) }>
        <Icon icon='admin' text={t("app.actions.admin")} />
      </Button>
      <Button onClick={()=>( window.location = `/apps/${appId}/cmp/analytics`) }>
        <Icon icon='configure' text={t("app.actions.cmp_analytics")} />
      </Button>
      <Button onClick={()=>( history.push(`/apps/${appId}/cmp/configuration`)) }>
          <Icon icon='check-square' text={t("app.actions.cmp_configuration")} />
      </Button>
      <Button onClick={()=>( history.push(`/apps/${appId}/sdk/remote_configuration`)) }>
          <Icon icon='branch' text={t("app.actions.remote_params")} />
      </Button>
    </Title>
    <Row>
      <FilterGroup fireOnChangeAtMount={true} onChange={setFilter} >
        <DateRangeFilterButton
          startDate={app.start_date}
          endDate={app.end_date}
        />
        <FilterButton
          title={t("app.app_version")}
          options={app_versions}
          selected={selectedAppVersion}
          search={true}
          includeAll={true}
          name="app_version"/>
        <FilterButton
          title={t("app.sdk_version")}
          options={sdk_versions}
          selected={selectedSdkVersion}
          search={true}
          includeAll={true}
          name="sdk_version"/>
      </FilterGroup>
    </Row>
    <Kpis data={app}/>
    <Tabs active={"devices"}>
      <LazyLoad icon={"mobile"} as={"devices"}>
        <DataByDay appId={appId} filter={filter}/>
      </LazyLoad>
      <LazyLoad icon={"consent"} as={"consent"}>
        <ConsentTab appId={appId} filter={filter} />
      </LazyLoad>
      <LazyLoad icon={"version"} as={"version"}>
        <VersionTab appId={appId} filter={filter} setFilter={setFilter} />
      </LazyLoad>
    </Tabs>
  </> );
}

export default App;
